import {
  data as categoriesData
} from '@lba-dev/package.local-globals/categories';
import { data as paidStatus } from '@lba-dev/package.local-globals/paidStatus';
import { data as AStatus } from '@lba-dev/package.local-globals/aStatus';
import {
  data as ASubStatus,
  AS_QUA,
} from '@lba-dev/package.local-globals/aSubStatus';
import { data as aLevel, NOT_QUA } from '@lba-dev/package.local-globals/aLevel';
import { data as ADossier } from '@lba-dev/package.local-globals/dossier';
import {
  data as IStatus,
  I_AVR,
  I_VRF,
  I_ANN,
} from '@lba-dev/package.local-globals/iStatus';
import {
  data as demandeStatus,
  D_REF,
} from '@lba-dev/package.local-globals/demandeStatus';
import { R_POR, R_FOR } from '@lba-dev/package.local-globals/remStatus';
import { data as SAVStatus } from '@lba-dev/package.local-globals/SAVStatus';
import { MIN_DURATION } from '@lba-dev/package.local-globals/minDuration';
import {
  REPONDEUR,
  OK,
  RDVCONFIRMED,
  isProblem,
} from '@lba-dev/package.local-globals/callTypes';

import { firstCallFilters } from '../../utils/function';
import store from '../../store';

const equipeAreas = (name) => (value) => {
  const user = store
    .getState()
    .users.find(
      (e) => e.act && e.login.toUpperCase().match(`^${value.toUpperCase()}`)
    );
  return {
    [name]: {
      $in: user && user.areas ? user.areas.map((e) => `/^${e}/`) : [],
    },
  };
};

export function convertiFilterData(value, data, findField, toReturnField) {
  return data.reduce((v, c) => {
    if (findField.some((e) => new RegExp(`^${value}`, 'gi').test(c[e]))) {
      v.push(c[toReturnField]);
    }
    return v;
  }, []);
}

export const callBackFunction = {
  'currentArtisan.source': value => ({
    'currentArtisan.source': {
      $regex: `${value.escapeRegExp()}`,
      $options: 'i',
    },
  }),
  dateMeeting: (value) => ({
    1: {
      'date.createMeeting': { $exists: true },
      'date.meeting': { $exists: false },
      'date.declinedMeeting': { $exists: false },
    },
    2: {
      'date.meeting': { $exists: true },
      'date.declinedMeeting': { $exists: false },
    },
    3: {
      'date.declinedMeeting': { $exists: true },
    },
  }[value] || {}),
  // 0 : tous les devis qui n'ont pas de délai à respecter.
  // 1 : le reste qui sont en attente de la fin du délai légal de rétractation.
  retractation: (value) => ({
    0: { 'date.retractationEnd': { $exists: false } },
    1: { 'date.retractationEnd': { $exists: true } },
  }[value] || {}),
  categorie: (value) => {
    const data = convertiFilterData(
      value,
      categoriesData,
      ['name', 'shortName'],
      '_id'
    );
    return data.length ? { categorie: { $in: data } } : null;
  },
  categories: (value) => {
    if (value === '0') {
      return { categories: [] };
    }
    const data = convertiFilterData(
      value,
      categoriesData,
      ['name', 'shortName'],
      '_id'
    );
    return data.length ? { categories: { $in: data } } : null;
  },
  paid: (value) => {
    const data = convertiFilterData(
      value,
      paidStatus,
      ['name', 'shortName'],
      '_id'
    );
    return data.length ? { paid: { $in: data } } : null;
  },
  grandCompte: (value, dataToFind) => {
    const data = convertiFilterData(
      value,
      dataToFind,
      ['companyName', 'name', 'firstname'],
      '_id'
    );
    return data.length ? { 'billing.grandCompte': { $in: data } } : null;
  },
  source: (value) => ({
    source: { $regex: `${value.escapeRegExp()}`, $options: 'i' },
  }),
  choice: (value) => ({
    choice: { $regex: `${value.escapeRegExp()}`, $options: 'i' },
  }),
  sChoice: (value) => ({
    sChoice: { $regex: `${value.escapeRegExp()}`, $options: 'i' },
  }),
  companyName: (value) => ({
    companyName: { $regex: `^${value.toUpperCase().escapeRegExp()}` },
  }),
  clientZipCode: (value) => ({
    'client.zipCode': { $regex: `^${value.escapeRegExp()}` },
  }),
  sStatus: (value) => {
    if (isNaN(value)) {
      return {
        'sStatus.path': { $regex: `/${value.escapeRegExp()}`, $options: 'i' },
      };
    }
    const confCand = store
      .getState()
      .confCand.toJS()
      .find((e) => e.id === Number(value) && e.path !== '');
    const path =
      confCand && confCand.path === '/Refusé' ? confCand.name : confCand.path;
    return confCand && { 'sStatus.path': { $regex: `${confCand && path}` } };
  },
  AStatus: (value) => {
    const data = convertiFilterData(
      value,
      AStatus,
      ['name', 'shortName'],
      '_id'
    );
    return data.length ? { status: { $in: data } } : null;
  },
  ASubStatus: (value) => {
    const data = convertiFilterData(
      value,
      ASubStatus,
      ['name', 'shortName'],
      '_id'
    );
    let query = null;
    if (data.length) {
      query = { subStatus: { $in: data } };
      if (data.includes(AS_QUA)) {
        query = { level: { $ne: NOT_QUA } };
      }
    }
    return query;
  },
  AStatusCandidat: (value) => {
    const data = convertiFilterData(
      value,
      AStatus,
      ['name', 'shortName'],
      '_id'
    );
    return data.length ? { 'currentArtisan.status': { $in: data } } : null;
  },
  ASubStatusCandidat: (value) => {
    const data = convertiFilterData(
      value,
      ASubStatus,
      ['name', 'shortName'],
      '_id'
    );
    let query = null;
    if (data.length) {
      query = { 'currentArtisan.subStatus': { $in: data } };
    }
    return query;
  },
  ALevel: (value) => {
    const data = convertiFilterData(value, aLevel);
    return data.length ? { level: data } : null;
  },
  dossier: (value) => {
    const data = ADossier.find((d) =>
      d.name.toLowerCase().startsWith(value.toLowerCase())
    );
    return { _dossier: data._id };
  },
  remuneration: (value) => {
    if (isNaN(value)) {
      if (value === 'POR') {
        return { 'remuneration.status': R_POR };
      } else if (value === 'FOR') {
        return { 'remuneration.status': R_FOR };
      }
    }
    return {
      'remuneration.pourcentage.labor': Number(value),
      'remuneration.status': R_POR,
    };
  },
  iStatus: (value) => {
    IStatus.push({
      _id: IStatus.length + 1,
      value: { isProforma: true, status: I_VRF },
    });
    IStatus.push({
      _id: IStatus.length + 1,
      value: { noPaymentReceived: true, status: I_AVR },
    });
    IStatus.push({
      _id: IStatus.length + 1,
      value: { emptyCancel: true, status: I_ANN },
    });
    const data = IStatus.find((d) => d._id === +value);
    if (data && typeof data.value === 'object') {
      return data.value;
    }
    return value ? { status: +value } : null;
  },
  debriefUser: (value) => {
    const users = store
      .getState()
      .users.filter((e) =>
        e.login.toUpperCase().match(`^${value.toUpperCase().escapeRegExp()}`)
      )
      .map((e) => e._id);
    return {
      'login.debrief': { $in: users.toArray() },
    };
  },

  equipeAreasArtisan: equipeAreas('billingAddress.zipcode'),
  equipeAreasCandidats: equipeAreas('address.zipcode'),
  equipeAreasClient: equipeAreas('client.address.zipcode'),
  savStatus: (value) => {
    const data = convertiFilterData(
      value,
      SAVStatus,
      ['name', 'shortName'],
      '_id'
    );
    return data.length ? { status: { $in: data } } : null;
  },
  dStatus: (value) => {
    const data = convertiFilterData(
      value,
      demandeStatus,
      ['name', 'shortName'],
      '_id'
    );
    if (value) {
      return data && data.length
        ? { status: { $in: data } }
        : { status: D_REF, raisonRefus: { $regex: value, $options: 'i' } };
    }
    return null;
  },
  firstCall: (value) => firstCallFilters(value),
  appel: (value) => ({
    1: {
      'login.miseEnRelation': { $exists: false },
      'communications.0': { $exists: true },
      'communications.type': { $exists: true },
      communications: {
        $not: {
          $elemMatch: {
            duration: { $gt: MIN_DURATION },
            type: { $not: { $all: [OK, RDVCONFIRMED] } },
          },
        },
        $elemMatch: {
          type: { $not: { $all: [REPONDEUR] } },
        },
      },
    },
    2: {
      'login.miseEnRelation': { $exists: false },
      communications: {
        $elemMatch: {
          duration: { $gt: MIN_DURATION },
          type: { $not: { $all: [REPONDEUR] } },
          played: { $not: { $all: [true] } },
        },
      },
    },
    3: {
      'login.miseEnRelation': { $exists: false },
      communications: {
        $elemMatch: {
          duration: { $gt: MIN_DURATION },
          type: { $in: isProblem },
          played: true,
        },
      },
    },
    4: {
      'login.miseEnRelation': { $exists: false },
      communications: {
        $not: {
          $elemMatch: {
            duration: { $gt: MIN_DURATION },
            type: { $ne: REPONDEUR },
          },
        },
      },
    },
    5: {
      'login.miseEnRelation': { $exists: false },
      'communications.0': { $exists: true },
      communications: {
        $not: { $elemMatch: { type: { $ne: REPONDEUR } } },
      },
    },
    6: {
      'login.miseEnRelation': { $exists: true },
      appel: true,
      'communications.type': { $exists: true },
      communications: {
        $not: {
          $elemMatch: {
            duration: { $gt: MIN_DURATION },
            type: { $not: { $all: [OK, RDVCONFIRMED] } },
          },
        },
      },
    },
    7: {
      'login.miseEnRelation': { $exists: true },
      communications: {
        $elemMatch: {
          duration: { $gt: MIN_DURATION },
          type: { $not: { $all: [REPONDEUR] } },
          played: { $not: { $all: [true] } },
        },
      },
    },
    8: {
      'login.miseEnRelation': { $exists: true },
      appel: true,
      communications: {
        $elemMatch: {
          duration: { $gt: MIN_DURATION },
          type: { $in: isProblem },
          played: true,
        },
      },
    },
    9: {
      'login.miseEnRelation': { $exists: true },
      appel: true,
      communications: {
        $not: { $elemMatch: { type: { $ne: REPONDEUR } } },
      },
    },
  }[value] || {}),
  service: (value) => ({
    'service.desc': { $regex: value.escapeRegExp(), $options: 'i' },
  }),
  isPriority: (value) => ({
    isPriority: !!value,
    'date.meeting': { $exists: true },
    'date.declinedMeeting': { $exists: false }
  }),
};
